import { useState } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Hidden,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Layout from "../components/layout/Layout";
import GlobalBarChart from "../components/analytics/LineChart";
import LinkChart from "../components/analytics/LinkChart";
import UploadingApp from "../components/apps-components/UploadingApplication";
import MyDropzone from "../components/dashboard-components/dropzone-component";
import Footer from "../components/layout/Footer";
import reportWebVitals from "../reportWebVitals";
import { useTranslation } from "react-i18next";
import { Smartphone } from "@mui/icons-material";
import { useDownloadApps, useDownloadLinks } from "../../src/pages/api/api";

/* Dashboard Page --> A responsive <Grid /> composed of 4 main components: 
  <UploadApp />, <MyDropzone/> (in ../components/dashboard-components) and 
  2 analytical components (in ../components/analytics) */
function Dashboard() {
  const { t } = useTranslation();

  /* State variables for Drag and Drop component */
  const [file, setFile] = useState<File>();
  const [openUploadDialog, setOpenUploadDialog] = useState(false);

  /* API calls to populate charts and components */
  const {
    downloadsPerApps,
    isLoadingDownloadsPerApps,
    isErrorDownloadsPerApps,
  } = useDownloadApps();
  const {
    downloadsPerLinks,
    isLoadingDownloadsPerLinks,
    isErrorDownloadsPerLinks,
  } = useDownloadLinks();

  const download4Plot = downloadsPerApps
    .map((item) => item.versions)
    .flat()
    .map((item) => item.downloads)
    .flat();

  return (
    <>
      <div className="Dashboard">
        <Layout />
        <Container disableGutters={true} sx={{ mt: 3 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            marginBottom={2}
          >
            <Typography variant="h3">
              {t("Welcome back, ") +
                localStorage.getItem("Name") +
                " " +
                localStorage.getItem("Surname")}
            </Typography>
            <Hidden mdDown>
              <Button
                variant="contained"
                onClick={() => setOpenUploadDialog(true)}
                startIcon={<Smartphone />}
              >
                {t("New Application")}
              </Button>
            </Hidden>
            <Hidden mdUp>
              <IconButton
                onClick={() => setOpenUploadDialog(true)}
                color={"primary"}
              >
                <FileUploadIcon sx={{ width: 35, height: 35 }} />
              </IconButton>
            </Hidden>
          </Stack>
          <Stack direction="row" justifyContent="end" marginBottom={2}>
            <UploadingApp
              buttonText={t("Upload")}
              dialogTitle={t("Upload a new application")}
              openDialog={openUploadDialog}
              isDashboard={true}
              updateOpenUploadDialog={setOpenUploadDialog}
              file={file}
              updateFile={setFile}
            />
          </Stack>

          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <MyDropzone
                openUploadDialog={openUploadDialog}
                updateOpenUploadDialog={setOpenUploadDialog}
                file={file}
                updateFile={setFile}
              />
            </Grid>
            <Divider />
            <Grid item xs={12} md={6} lg={6}>
              <GlobalBarChart
                title={t("Aggregated total downloads")}
                downloads={download4Plot}
                loading={isLoadingDownloadsPerApps}
                isError={isErrorDownloadsPerApps}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <LinkChart
                downloads={downloadsPerLinks}
                loading={isLoadingDownloadsPerLinks}
                isDashboard={true}
                isError={isErrorDownloadsPerLinks}
              />
            </Grid>
          </Grid>
        </Container>
      </div>
      <div
        style={{
          position: "relative",
          left: 0,
          bottom: 0,
          right: 0,
          paddingTop: 40,
        }}
      >
        <Footer />
      </div>
    </>
  );
}

export default Dashboard;

reportWebVitals();
